exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-3a83b951] {\n  cursor: pointer;\n}\n.bg-img[data-v-3a83b951] {\n  background-color: #15273d;\n}\n.description[data-v-3a83b951] {\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  line-clamp: 3;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  min-height: 85px;\n  max-height: 85px;\n  font-size: 18px;\n  margin-top: 14px;\n}", ""]);

// exports
